/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneVm
 */
export interface PhoneVm {
    /**
     * 
     * @type {string}
     * @memberof PhoneVm
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneVm
     */
    areaCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PhoneVm
     */
    number?: string | null;
}

export function PhoneVmFromJSON(json: any): PhoneVm {
    return PhoneVmFromJSONTyped(json, false);
}

export function PhoneVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'areaCode': !exists(json, 'areaCode') ? undefined : json['areaCode'],
        'number': !exists(json, 'number') ? undefined : json['number'],
    };
}

export function PhoneVmToJSON(value?: PhoneVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countryCode': value.countryCode,
        'areaCode': value.areaCode,
        'number': value.number,
    };
}


